import { Invite } from 'components/Invite/Invite'
import { AppPageLayout } from 'components/layouts/AppPageLayout'
import React from 'react'
import { useGoBack } from 'services/router/useGoBack.hook'
import { useDispatchHook } from 'state/store'
import { Images } from 'theme/Images'
import {
  useAdminInviteState,
  useNextAdminInviteState,
} from './AdminInvite.restate'
import { useIntl } from 'react-intl'

import messages from './AdminInvite.messages'
import { setInstitutePageTabIndex } from 'pages/Institute/Institute.page-service'

export const AdminInvite: React.FC<{}> = () => {
  const intl = useIntl()
  const inviteCardTitle = intl.formatMessage(messages.inviteCardTitle)

  const dispatch = useDispatchHook()
  const goBack = useGoBack()
  const send = useAdminInviteState(s => s.send)
  const next = useNextAdminInviteState(s => s)
  return (
    <AppPageLayout title={inviteCardTitle} showBackButton>
      <Invite
        title={inviteCardTitle}
        send={send}
        onCancel={() => {
          setInstitutePageTabIndex(1)
          goBack()
          next(s => {
            s.send = false
          })
        }}
        onOk={() => {
          setInstitutePageTabIndex(1)
          goBack()
          next(s => {
            s.send = false
          })
        }}
        onSend={payload => {
          dispatch({ type: 'Page/Service/AdminInvite/Invite', payload })
        }}
        imgSrc={Images.productTearDown}
      />
    </AppPageLayout>
  )
}

export default AdminInvite
